import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import mixpanel from 'utils/mixpanel/mixpanel';

import { PPTX_DOWNLOAD_START } from 'containers/App/constants';
import { makeSelectPptxDownloadActive } from 'containers/App/selectors';

import downloadGIF from 'images/loading.gif';

import Button from 'components/Button';

export const DownloadingGIF = styled(Button)`
  background-image: url('${downloadGIF}');
  background-size: 30px;
  background-position: center;
  display: block;
`;

export const Div = styled.div`
  ${({ active }) => active && 'z-index: 11;'}
`;

export const PptxButton = (props) => {
  const {
    pptxDownloadActive: downloading,
    download,
    cdf,
    pptxCdf,
    getChartInfo,
  } = props;

  const trackPPTXDownload = () => {
    const {
      Title: title,
      Subtitle: subtitle,
    } = getChartInfo();

    mixpanel.track('Download Chart', {
      question_code: pptxCdf?.QuestionCode || cdf.QuestionCode,
      chart_title: title,
      chart_subtitle: subtitle,
      download_type: 'PPTX',
    });
  };

  let html;
  if (downloading === false) {
    html = (
      <Button
        onClick={() => { download(pptxCdf || cdf); trackPPTXDownload(); }}
        title="Download PPTX"
        key="Button"
      >
        PPTX
      </Button>
    );
  } else {
    html = (
      <DownloadingGIF key="DisabledButton"></DownloadingGIF>
    );
  }
  return (
    <Div active={downloading}>
      {html}
    </Div>
  );
};

PptxButton.propTypes = {
  pptxDownloadActive: PropTypes.bool,
  download: PropTypes.func,
  cdf: PropTypes.object,
  pptxCdf: PropTypes.object,
  getChartInfo: PropTypes.func,
};

export const mapDispatchToProps = (dispatch) => ({
  download: (cdf) => {
    dispatch({ type: PPTX_DOWNLOAD_START, cdf });
  },
});

const mapStateToProps = createStructuredSelector({
  pptxDownloadActive: makeSelectPptxDownloadActive(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(PptxButton);



// WEBPACK FOOTER //
// ./app/components/Chart/DownloadButtons/pptx_button.js